// libs
import {
  getABExperimentVariant
} from '@nykaa/experiment-sdk/store/selectors';
import { useSelector } from 'react-redux';

// store
import { getStore } from 'shared/store';

/**
 * Function to retrieve the eligible variant name for a given experiment ID.
 *
 * @param {string} id - The experiment ID.
 * @returns {Object} - An object containing isEligible and variant (if eligible).
 */
export const getEligibleVariantName = (
  id: string,
  abExperiments = getStore()?.getState()?.abExperiments || {}
) => {
  // Access global Redux state
  const globalState = getStore()?.getState() || {};
  // Check if ExperimentV2 is enabled
  const experimentV2Enabled = globalState.remoteConfigs?.isExperimentV2Enabled || false;

  // Retrieve experiment variant and eligibility
  const { isEligible = false, variant = '' } = getABExperimentVariant(
    { abExperiments },
    id
  );

  // Return the result based on eligibility
  if (experimentV2Enabled && isEligible) {
    return { isEligible, variant };
  }

  return { isEligible: false };
};

export const useEligibleSSRVariantName = (id: string) => {
  const abExperiments = useSelector(
    (state: { abExperiments: Record<string, string> }) => state.abExperiments
  );
  return getEligibleVariantName(id, abExperiments);
};